// extracted by mini-css-extract-plugin
module.exports = {"content":"InformationEditDialog_content__xSrIY"};